import { memo } from "react";
import PropTypes from "prop-types";
import { FormattedMessage, FormattedPlural } from "react-intl";
import { Amount } from "app/components/ui/Amount/Amount";
import { OFFER_PRICE_TYPES, ICON_SIZES } from "app/constants";
import { fromPriceTypeShape } from "app/utils/propTypes";
import "./From.scss";
import AirplaneFilledIcon from "app/icons/travel/AirplaneFilledIcon";
import Typography, { TYPOGRAPHY_VARIANTS } from "app/pages/.shared/Typography/Typography";

const From = ({
	travelByTrainAvailable,
	value,
	pricePrefix,
	priceSuffix,
	publicPrice,
	offerPriceType,
	includeOfferWithFlight,
	publicPricePrefix,
	isWithHotel,
	duration,
	showFromInfo = true,
}) => {
	const nightCount = { count: duration };

	return (
		<div className="from">
			<div className="from__price">
				<div className="from__value" data-testid="from-value">
					<Amount
						value={Number(value)}
						size="xl5"
						prefix={pricePrefix}
						suffix={priceSuffix}
					/>
				</div>

				{publicPrice > 0 && (
					<Typography
						variant={TYPOGRAPHY_VARIANTS.REGULAR}
						data-testid="from-public-price"
						component="p"
					>
						{publicPricePrefix}

						<Amount value={publicPrice} className="from__public-price" />
					</Typography>
				)}
			</div>
			{showFromInfo && (
				<div className="from__info">
					{isWithHotel ? (
						<FormattedPlural
							value={duration}
							one={
								<FormattedMessage
									id="general.hotel.nights.count.singular"
									values={nightCount}
								/>
							}
							other={
								<FormattedMessage
									id="general.hotel.nights.count"
									values={nightCount}
								/>
							}
						/>
					) : (
						<FormattedPlural
							value={duration}
							one={
								<FormattedMessage
									id="general.nights.count.singular"
									values={nightCount}
								/>
							}
							other={
								<FormattedMessage id="general.nights.count" values={nightCount} />
							}
						/>
					)}
					<div className="from__flight">
						{offerPriceType === OFFER_PRICE_TYPES.FROM_PRICE_TYPE_FROM_WITH_FLIGHT &&
							includeOfferWithFlight === true && (
								<div className="from__flight--included">
									{travelByTrainAvailable ? (
										<FormattedMessage id="general.included.transport" />
									) : (
										<FormattedMessage id="general.included.flight" />
									)}
									{travelByTrainAvailable === false && (
										<AirplaneFilledIcon
											size={ICON_SIZES.XS}
											className="icon--flight"
										/>
									)}
								</div>
							)}

						{offerPriceType === OFFER_PRICE_TYPES.FROM_PRICE_TYPE_FROM &&
							includeOfferWithFlight === true &&
							(!travelByTrainAvailable ? (
								<FormattedMessage id="general.excluded.flight" />
							) : (
								<FormattedMessage id="general.excluded.transport" />
							))}
					</div>
				</div>
			)}
		</div>
	);
};

From.propTypes = {
	travelByTrainAvailable: PropTypes.bool,
	value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
	includeOfferWithFlight: PropTypes.bool,
	pricePrefix: PropTypes.oneOfType([PropTypes.string, PropTypes.element]),
	priceSuffix: PropTypes.oneOfType([PropTypes.string, PropTypes.element]),
	publicPricePrefix: PropTypes.oneOfType([PropTypes.string, PropTypes.element]),
	publicPrice: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
	offerPriceType: fromPriceTypeShape,
	isWithHotel: PropTypes.bool,
	duration: PropTypes.number,
	showFromInfo: PropTypes.bool,
};

export default memo(From);
